/*
 * Lib Module Animations
 */

Lib.Animation = (function() {
    var self = {};

    // Document ready
    $(Lib).on('document.ready', function() {
        self.ripple();
    });

    self.ripple = function() {
        $.ripple.destroy();
        $('.button:not([disabled]), .dropdown-list a, .dropdown-list button, .left-menu a, .actions a, .top-menu ul li a, .nav-toggle, .sidebar-left a, .tab-menu li a, .ripple').not('.legitRipple, .no-ripple, .no-ripple *, .single-tab *').ripple({
            allowDragging: true,
            dragging: false,
            scaleModel: 0
        });

    };

    /**
     * Disable all animations
     * @returns true
     */
    self.disable = function() {
        $.fx.off = true;
        $('html').addClass('no-animations');
        return true;
    };

    /**
     * Enable all animations
     * @returns {boolean}
     */
    self.enable = function() {
        $.fx.off = false;
        $('html').removeClass('no-animations');
        return true;
    };

    /**
     * Toggle animations
     */
    self.toggle = function() {
        $.fx.off = !$.fx.off;
        $('html').toggleClass('no-animations');
        return $.fx.off;
    };

    self.blink = function(el, fast, addedClass) {

        if (typeof el === 'string') {
            el = $(el);
        }

        if (el.length === 0) {
            return self;
        }

        addedClass = addedClass || 'bg-yellow-lighter';
        var timeout = (fast) ? 1000 : 2000;
        var defaultAddClasses = ' lib-animated';
        if (fast) {
            defaultAddClasses += ' animated-fast';
        }
        el.addClass(defaultAddClasses);
        el.addClass(addedClass);
        setTimeout(function() {
            el.removeClass(addedClass);
            setTimeout(function() {
                el.removeClass(defaultAddClasses);
            }, timeout);
        }, timeout);
    };

    return self;

})();
